"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var video = document.getElementsByClassName('hero-video__video')[0];
    var activeClass = 'hero-video__video--active';
    var $content = $('.hero-video__content');
    $('.hero-video__play-button').on('click', function () {
        video.play();
        $content.fadeOut();
        $(video).addClass(activeClass);
    });
    $('.hero-video__video-wrapper').on('click', function () {
        video.pause();
        $content.fadeIn();
    });
};
exports.init = init;
